// SEO Configuration for all pages
export const seoConfig = {
  home: {
    title: 'Africa Respiratory Care Association - Empowering Africa\'s Healthcare',
    description: 'ARCA empowers Africa\'s respiratory care professionals through education, training, research, and advocacy. Join 5,000+ members across 25 African countries in creating sustainable solutions for better breathing and better care.',
    keywords: 'respiratory care Africa, ARCA, healthcare professionals, respiratory therapy training, pulmonary care, breathing health, medical education Africa, ventilation training, oxygen therapy, critical care',
    url: '/'
  },
  about: {
    title: 'About ARCA - Our Story & Mission | Africa Respiratory Care Association',
    description: 'Learn about ARCA\'s journey in transforming respiratory healthcare across Africa. Discover our mission, vision, and the passionate team dedicated to excellence in respiratory care for all Africans.',
    keywords: 'ARCA history, about ARCA, respiratory care mission, healthcare Africa, ARCA team, Pan-African healthcare',
    url: '/about'
  },
  ourStory: {
    title: 'Our Story - How ARCA Began | Africa Respiratory Care Association',
    description: 'From humble beginnings to serving 5,000+ members across 25 African countries - discover the inspiring story of ARCA and our commitment to respiratory care excellence.',
    keywords: 'ARCA story, organization history, respiratory care Africa, healthcare development',
    url: '/about/our-story'
  },
  missionVision: {
    title: 'Mission & Vision - ARCA\'s Commitment to Africa | Respiratory Care',
    description: 'ARCA\'s mission is to unite Africa\'s respiratory professionals to create sustainable solutions for better breathing, better care, and better lives across the continent.',
    keywords: 'ARCA mission, ARCA vision, respiratory care goals, healthcare objectives Africa',
    url: '/about/mission-vision'
  },
  leadership: {
    title: 'Leadership & Board of Trustees | Africa Respiratory Care Association',
    description: 'Meet ARCA\'s dedicated leadership team and Board of Trustees committed to advancing respiratory care excellence across Africa.',
    keywords: 'ARCA leadership, board of trustees, healthcare leaders Africa, respiratory care experts',
    url: '/about/leadership'
  },
  presidentMessage: {
    title: 'President\'s Message - Dorothy H. Bendah | ARCA',
    description: 'Read a message from ARCA President Dorothy H. Bendah on our mission to unite Africa\'s respiratory professionals for better healthcare outcomes.',
    keywords: 'Dorothy Bendah, ARCA president, president message, respiratory care leadership',
    url: '/about/president-message'
  },
  partners: {
    title: 'Partners & Collaborators | Africa Respiratory Care Association',
    description: 'ARCA collaborates with leading global health organizations including WHO, IARC, and regional healthcare partners to advance respiratory care in Africa.',
    keywords: 'ARCA partners, healthcare collaborators, WHO partnership, medical partnerships Africa',
    url: '/about/partners'
  },
  educationTraining: {
    title: 'Education & Training Programs | ARCA Respiratory Care',
    description: 'Comprehensive respiratory care training programs for healthcare professionals. Join ARCA\'s 150+ training sessions and advance your career in respiratory therapy.',
    keywords: 'respiratory training, medical education, healthcare courses Africa, respiratory therapy certification, ventilation training',
    url: '/programs/education-training'
  },
  research: {
    title: 'Research & Innovation - Advancing Respiratory Care | ARCA',
    description: 'ARCA drives cutting-edge research and innovation in respiratory care across Africa, developing solutions tailored to African healthcare challenges.',
    keywords: 'respiratory research, medical innovation Africa, healthcare research, pulmonary studies',
    url: '/programs/research-innovation'
  },
  advocacy: {
    title: 'Advocacy & Awareness Programs | Africa Respiratory Care',
    description: 'ARCA advocates for better respiratory healthcare policies and raises awareness about breathing health across Africa.',
    keywords: 'healthcare advocacy, respiratory awareness, health policy Africa, breathing health campaigns',
    url: '/programs/advocacy-awareness'
  },
  equipment: {
    title: 'Equipment & Resource Support | ARCA Healthcare Solutions',
    description: 'ARCA provides essential respiratory care equipment and resources to healthcare facilities across Africa, improving patient outcomes.',
    keywords: 'medical equipment Africa, respiratory resources, healthcare supplies, ventilators Africa',
    url: '/programs/equipment-support'
  },
  chapters: {
    title: 'ARCA Chapters - Pan-African Presence | Country Chapters',
    description: 'Explore ARCA chapters across Africa including Ghana, Egypt, Ethiopia, Liberia, Lebanon and more. Join your local respiratory care community.',
    keywords: 'ARCA chapters, respiratory care Ghana, healthcare Ethiopia, medical associations Africa',
    url: '/chapters'
  },
  events: {
    title: 'Events & Conferences | Africa Respiratory Care Association',
    description: 'Join ARCA events, conferences, and training sessions. Connect with respiratory care professionals and stay updated on the latest in respiratory healthcare.',
    keywords: 'ARCA events, respiratory conferences, medical seminars Africa, healthcare workshops',
    url: '/events'
  },
  volunteer: {
    title: 'Volunteer with ARCA - Make a Difference in African Healthcare',
    description: 'Join ARCA as a volunteer and contribute to improving respiratory care across Africa. Share your expertise and make a lasting impact.',
    keywords: 'volunteer Africa, healthcare volunteering, medical volunteer opportunities, ARCA volunteer',
    url: '/get-involved/volunteer'
  },
  donate: {
    title: 'Donate to ARCA - Support Respiratory Care in Africa',
    description: 'Your donation helps ARCA provide training, equipment, and resources to respiratory care professionals across Africa. Every contribution makes a difference.',
    keywords: 'donate ARCA, healthcare donations, support African healthcare, medical charity Africa',
    url: '/get-involved/donate'
  },
  membership: {
    title: 'Join ARCA - Become a Member | Respiratory Care Professionals',
    description: 'Join 5,000+ respiratory care professionals across Africa. ARCA membership offers training, networking, resources, and career development opportunities.',
    keywords: 'ARCA membership, join respiratory care association, healthcare membership Africa, professional development',
    url: '/membership_registration'
  },
  virtualUniversity: {
    title: 'Virtual University - Online Respiratory Care Courses | ARCA',
    description: 'Access ARCA\'s Virtual University for comprehensive online respiratory care courses, certifications, and continuing education programs.',
    keywords: 'online medical courses, respiratory care online, virtual medical training, e-learning healthcare Africa',
    url: '/university'
  },
  store: {
    title: 'ARCA Store - Respiratory Care Equipment & Resources',
    description: 'Shop quality respiratory care equipment, educational materials, and professional resources at the ARCA Store.',
    keywords: 'medical equipment store, respiratory supplies, healthcare products Africa, ARCA merchandise',
    url: '/store'
  },
  contact: {
    title: 'Contact ARCA - Get in Touch | Africa Respiratory Care Association',
    description: 'Contact ARCA for membership inquiries, partnership opportunities, or general information about respiratory care in Africa.',
    keywords: 'contact ARCA, healthcare inquiries, ARCA email, respiratory care contact',
    url: '/contact'
  },
  news: {
    title: 'News & Updates | Africa Respiratory Care Association',
    description: 'Stay updated with the latest news, announcements, and developments from ARCA and the respiratory care community across Africa.',
    keywords: 'ARCA news, respiratory care updates, healthcare news Africa, medical announcements',
    url: '/news'
  },
  resources: {
    title: 'Resources Hub - Clinical Guidelines & Publications | ARCA',
    description: 'Access ARCA\'s comprehensive resources including clinical guidelines, research publications, training materials, and policy documents.',
    keywords: 'respiratory care resources, clinical guidelines, medical publications, healthcare documents Africa',
    url: '/resources'
  },
  arca2027Survey: {
    title: 'ARCA 2027 Conference Survey - Help Shape Africa\'s First International Respiratory Conference',
    description: 'Help shape ARCA\'s first-ever International Conference in Accra, Ghana (October 7-9, 2027). Share your feedback on topics, speakers, and preferences in this 2-3 minute survey.',
    keywords: 'ARCA 2027, conference survey, respiratory care conference Africa, Accra conference, international respiratory conference, healthcare survey',
    url: '/conference/arca-2027-survey'
  }
};

// Helper function to get SEO config for a specific page
export const getSEOConfig = (page) => {
  return seoConfig[page] || seoConfig.home;
};

// Generate breadcrumb structured data
export const generateBreadcrumbSchema = (breadcrumbs) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': breadcrumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': crumb.name,
      'item': `https://www.africaresp.org${crumb.url}`
    }))
  };
};

// Generate event structured data
export const generateEventSchema = (event) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Event',
    'name': event.title,
    'description': event.description,
    'startDate': event.startDate,
    'endDate': event.endDate,
    'eventStatus': 'https://schema.org/EventScheduled',
    'eventAttendanceMode': event.isVirtual ? 'https://schema.org/OnlineEventAttendanceMode' : 'https://schema.org/OfflineEventAttendanceMode',
    'location': event.isVirtual ? {
      '@type': 'VirtualLocation',
      'url': event.registrationUrl
    } : {
      '@type': 'Place',
      'name': event.location,
      'address': event.address
    },
    'organizer': {
      '@type': 'Organization',
      'name': 'Africa Respiratory Care Association',
      'url': 'https://www.africaresp.org'
    }
  };
};

// Generate course structured data
export const generateCourseSchema = (course) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Course',
    'name': course.title,
    'description': course.description,
    'provider': {
      '@type': 'Organization',
      'name': 'Africa Respiratory Care Association',
      'sameAs': 'https://www.africaresp.org'
    },
    'courseCode': course.courseCode,
    'educationalLevel': course.level,
    'hasCourseInstance': {
      '@type': 'CourseInstance',
      'courseMode': 'online',
      'courseWorkload': course.duration
    }
  };
};

// Generate article/news structured data
export const generateArticleSchema = (article) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': article.title,
    'description': article.excerpt,
    'image': article.image,
    'datePublished': article.publishDate,
    'dateModified': article.modifiedDate || article.publishDate,
    'author': {
      '@type': 'Organization',
      'name': 'Africa Respiratory Care Association'
    },
    'publisher': {
      '@type': 'Organization',
      'name': 'Africa Respiratory Care Association',
      'logo': {
        '@type': 'ImageObject',
        'url': 'https://www.africaresp.org/logo512.png'
      }
    }
  };
};

export default seoConfig;
